/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import 'es6-promise/auto';
import Vuex from 'vuex';
/**
 * import Store
 */
import {FrontUserStore} from './stores/FrontUserStore';
import Storage from 'vue-ls';

require('./bootstrap');
require('vuetify/dist/vuetify.min.css');
require('material-design-icons-iconfont/dist/material-design-icons.css');

window.Vue = require('vue');
Vue.use(Vuex);

window.Vuetify = require('vuetify');
Vue.use(Vuetify);

Vue.use(Storage);

/**
 * laravel-admin package
 */
global.jQuery = global.$ = window.$ = window.jQuery = require('jquery');
global.Cookies = window.Cookies = require('js-cookie');
global.axios = window.axios = require('axios');
global.Swal = window.Swal = require('sweetalert2');
global.moment = window.moment = require('moment');

/**
 * import static js
 */
global.appUtil = window.appUtil = require('./statics/util');
global.appFile = window.appFile = require('./statics/file');

const store = new Vuex.Store({
    modules: {
        auth: FrontUserStore,
    }
});
global.appStore = window.appStore = store;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('ButtonConfirm', require('./components/forms/buttonConfirmComponent').default);
Vue.component('ArrangementCalendar', require('./components/front/arrangement/CalendarComponent').default);
Vue.component('StaffQualifications', require('./components/admin/staff/QualificationsComponent').default);
Vue.component('UploadCompletionReports', require('./components/front/completionReports/UploadCompletionReportsComponent').default);
Vue.component('PaymentSpPaymentBase', require('./components/front/payments/SpPaymentBaseComponent').default);
Vue.component('PaymentSpBusinessDetail', require('./components/front/payments/SpBusinessDetailComponent').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
    el: '#app',
    store,
    data: () => ({
        drawer: false,
        snackbar: true,
        apiRequesting: false,
        apiRequestingId: 0,
        apiRequestingIds: [],
        storageKey: 'VueStorageApp'
    }),
    mounted() {
        setTimeout(function () {
            $('.loading-background').remove();
        }, 2000);
    },
    methods: {
        logout() {
            Vue.ls.clear();
            $('#logout-form').submit();
        },
        startApiRequest() {
            this.apiRequesting = true;
            this.apiRequestingId = this.apiRequestingId + 1;
            this.apiRequestingIds.push(this.apiRequestingId);
            return this.apiRequestingId;
        },
        endApiRequest(apiRequestingId) {
            this.apiRequestingIds = this.apiRequestingIds.filter(function (id) {
                return id !== apiRequestingId;
            });
            if (!this.apiRequestingIds.length) {
                this.apiRequesting = false;
            }
        },
        isApiRequesting() {
            return this.apiRequesting;
        },
        getStorageKey(key) {
            return this.storageKey + '-' + key;
        },
        getStorage(key) {
            let sectionKey = this.getStorageKey(key);
            return Vue.ls.get(sectionKey);
        },
        setStorage(key, value) {
            let sectionKey = this.getStorageKey(key);

            if (value !== null && typeof value === 'object') {
                value = JSON.stringify(value);
            }
            Vue.ls.set(sectionKey, value, 60 * 60 * 1000);
        },
    }
});
